import type { ButtonName, ModalName } from '@coursera/event-pulse-types';

/**
 * Analytics taxonomy for the Learners & Invitation surfaces (ENTADMIN-2220, M3 - FE Eventing
 * Requirements). Each constant holds the exact members of the matching
 * `@coursera/event-pulse-types` enum and is validated with `satisfies` so a value that drifts
 * from the SDK fails to compile. The SDK schema is the source of truth; these constants only
 * give the bundle readable, DRY names.
 */

export const LEARNERS_BUTTON = {
  ADD_LEARNERS_TO_GROUP: 'enterprise_admin_add_learners_to_group',
  CREATE_GROUP_COMPLETE: 'enterprise_create_program',
} as const satisfies Record<string, ButtonName>;

export const LEARNERS_MODAL = {
  INVITE_ASYNC: 'enterprise_admin_invite_async',
  INVITE_TO_GROUP_ASYNC: 'enterprise_admin_invite_to_group_async',
  ADD_TO_GROUP_ASYNC: 'enterprise_admin_add_to_group_async',
} as const satisfies Record<string, ModalName>;
